/* eslint-disable no-case-declarations */
import { POST_TRANSFEREE_SURVEY_SUCCESS } from 'modules/surveys/surveys.types';
import {
  DELETE_ADDRESS_SUCCESS,
  DELETE_AUTH_TRIP_SUCCESS,
  GET_ACTIVITY_LOG_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_AUTH_TRIPS_SUCCESS,
  GET_ALL_AUTH_SERVICES_FAILURE,
  GET_ALL_AUTH_SERVICES_REQUEST,
  GET_ALL_AUTH_SERVICES_SUCCESS,
  GET_AUTHORIZATIONS_FAILURE,
  GET_AUTHORIZATIONS_REQUEST,
  GET_AUTHORIZATIONS_SUCCESS,
  GET_PENDING_AUTHS_FAILURE,
  GET_PENDING_AUTHS_REQUEST,
  GET_PENDING_AUTHS_SUCCESS,
  GET_AUTH_CLIENT_POLICIES_REQUEST,
  GET_AUTH_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_DATE_SUMMARY_REQUEST,
  GET_AUTH_DATE_SUMMARY_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS,
  GET_AUTH_LIST_CLIENT_POLICIES_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_REQUEST,
  GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS,
  GET_AUTH_SUMMARY_REQUEST,
  GET_AUTH_SUMMARY_FAILURE,
  GET_AUTH_SERVICES_REQUEST,
  GET_AUTH_SERVICES_SUCCESS,
  GET_AUTH_SUMMARY_SUCCESS,
  GET_AUTH_TEAM_SUCCESS,
  GET_COMMUNICATION_INFO_REQUEST,
  GET_COMMUNICATION_INFO_SUCCESS,
  GET_DEPARTURE_ADDRESS_SUCCESS,
  GET_DESTINATION_ADDRESS_SUCCESS,
  GET_EMPLOYEE_INFO_REQUEST,
  GET_EMPLOYEE_INFO_SUCCESS,
  GET_FAMILY_PET_REQUEST,
  GET_FAMILY_PET_SUCCESS,
  GET_FAMILY_REQUEST,
  GET_FAMILY_SUCCESS,
  GET_SO_INFO_REQUEST,
  GET_SO_INFO_SUCCESS,
  GET_USER_SETTINGS_REQUEST,
  GET_USER_SETTINGS_SUCCESS,
  POST_ADDRESS_SUCCESS,
  POST_AUTH_CLIENT_POLICIES_SUCCESS,
  POST_AUTH_DATE_SUMMARY_SUCCESS,
  POST_AUTH_SERVICES_SUCCESS,
  POST_AUTH_TEAM_SUCCESS,
  POST_COMMUNICATION_INFO_SUCCESS,
  POST_DEPARTURE_ADDRESS_SUCCESS,
  POST_DESTINATION_ADDRESS_SUCCESS,
  POST_EMPLOYEE_INFO_SUCCESS,
  POST_FAMILY_PET_SUCCESS,
  POST_FAMILY_SUCCESS,
  POST_SO_INFO_SUCCESS,
  POST_USER_SETTINGS_SUCCESS,
  POST_AUTH_TRIP_SUCCESS,
  SET_AUTH_ID,
  SET_LOADING_COMPLETE,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_AUTHORIZATIONS_SUCCESS,
  UPDATE_AUTH_CLIENT_POLICIES_SUCCESS,
  UPDATE_AUTH_DATE_SUMMARY_SUCCESS,
  UPDATE_AUTH_SERVICES_SUCCESS,
  UPDATE_AUTH_TEAM_SUCCESS,
  UPDATE_COMMUNICATION_INFO_SUCCESS,
  UPDATE_DEPARTURE_ADDRESS_SUCCESS,
  UPDATE_DESTINATION_ADDRESS_SUCCESS,
  UPDATE_EMPLOYEE_INFO_SUCCESS,
  UPDATE_FAMILY_DATA,
  UPDATE_FAMILY_PET_DATA,
  UPDATE_FAMILY_PET_SUCCESS,
  UPDATE_FAMILY_SUCCESS,
  UPDATE_SO_INFO_SUCCESS,
  UPDATE_USER_SETTINGS_SUCCESS,
  UPDATE_AUTH_TRIP_SUCCESS,
  DELETE_AUTHORIZATION_BANKING_SUCCESS,
  UPDATE_AUTHORIZATION_BANKING_SUCCESS,
  POST_AUTHORIZATION_BANKING_SUCCESS,
  GET_AUTHORIZATION_BANKING_SUCCESS,
  POST_AUTHORIZATIONS_SUCCESS,
  GET_AUTHORIZATION_SENT_TEMPLATES_SUCCESS,
  UPDATE_AUTH_CUSTOM_FIELD_VALUE_SUCCESS,
  GET_FEE_RECORDS_SUCCESS,
  GET_SERVICE_STATUS_DATES_SUCCESS,
  GET_AUTH_SUMMARY_ADDRESS_SUCCESS,
  GET_AUTH_SUMMARY_ADDRESS_REQUEST,
  GET_AUTH_SUMMARY_ADDRESS_FAILURE
} from '../types/authorizationTypes';
import { GET_APPROVED_LINEITEM_SUMMARIES_SUCCESS, GET_EXPENSE_BY_AUTHORIZATION_SUCCESS } from 'modules/expenses/store/types';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

const handleAuthorizationReducer = (draft, action) => {
  if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].authDetails)
    draft.authorizationDetails[draft.currentAuthId].authDetails = {};

  switch (action.type) {
    case GET_AUTHORIZATIONS_REQUEST:
      draft.authorizationSummariesLoading = true;
      draft.isLoading = true;
      break;

    case GET_PENDING_AUTHS_REQUEST:
      draft.pendingAuthSummariesLoading = true;
      draft.isLoading = true;
      break;

    case GET_ALL_AUTH_SERVICES_REQUEST:
      draft.allServicesLoading = true;
      draft.isLoading = true;
      break;

    case GET_EMPLOYEE_INFO_REQUEST:
    case GET_SO_INFO_REQUEST:
    case GET_AUTH_SUMMARY_REQUEST:
    case GET_AUTH_SUMMARY_ADDRESS_REQUEST:
    case GET_AUTH_DATE_SUMMARY_REQUEST:
    case GET_COMMUNICATION_INFO_REQUEST:
    case GET_AUTH_CLIENT_POLICIES_REQUEST:
    case GET_AUTH_SERVICES_REQUEST:
    case GET_USER_SETTINGS_REQUEST:
    case GET_FAMILY_REQUEST:
    case GET_FAMILY_PET_REQUEST:
      draft.isLoading = true;
      break;

    case GET_AUTHORIZATIONS_FAILURE:
      draft.authorizationSummariesLoading = false;
      draft.isLoading = false;
      break;

    case GET_PENDING_AUTHS_FAILURE:
      draft.pendingAuthSummariesLoading = false;
      draft.isLoading = false;
      break;

    case GET_AUTH_SUMMARY_FAILURE:
    case GET_AUTH_SUMMARY_ADDRESS_FAILURE:
      draft.isLoading = false;
      break;

    case GET_AUTHORIZATIONS_SUCCESS:
      draft.authorizationSummariesLoading = false;
      draft.isLoading = false;
      draft.authorizationSummaries = action.response;
      break;

    case GET_PENDING_AUTHS_SUCCESS:
      draft.pendingAuthSummariesLoading = false;
      draft.isLoading = false;
      draft.pendingAuthSummaries = action.response;
      break;

    case GET_ALL_AUTH_SERVICES_FAILURE:
      draft.allServicesLoading = false;
      draft.isLoading = false;
      break;

    case GET_FEE_RECORDS_SUCCESS:
      draft.isLoading = false;
      draft.authorizationDetails[draft.currentAuthId].feeRecords = action.response;
      break;

    case GET_SERVICE_STATUS_DATES_SUCCESS:
      draft.isLoading = false;
      draft.authorizationDetails[draft.currentAuthId].serviceStatusDates = action.response;
      break;

    case GET_ALL_AUTH_SERVICES_SUCCESS:
      draft.allServicesLoading = false;
      draft.isLoading = false;
      draft.allServices = action.response;
      break;

    case SET_AUTH_ID:
      draft.currentAuthId = action.response;
      break;

    case GET_USER_SETTINGS_SUCCESS:
      draft.isLoading = false;
      draft.authorizationDetails[draft.currentAuthId].authDetails.userSettings = action.response;
      break;

    case SET_LOADING_COMPLETE:
      draft.isLoading = false;
      break;

    case GET_AUTH_SUMMARY_SUCCESS: {
      draft.isLoading = false;
      const { currentAuthId } = draft;
      const { response } = action;

      const destinationAddressId = response.authorizationDetails?.destinationAddressId;

      const updatedAddresses = response.addresses?.map(address => {
        const isDestinationType = isIdEqual(address.addressTypeId, 'C467FD82-E2D4-4D26-8827-5DF0A0B5C6A5');
        return {
          ...address,
          excludeAddressFromSelection: isDestinationType && address.addressId !== destinationAddressId
        };
      });

      // Update the reducer state
      draft.authorizationDetails[currentAuthId] = {
        ...response, // Keep other properties as-is
        addresses: updatedAddresses // Overwrite addresses with the new array containing excludeAddressFromSelection
      };
      break;
    }

    case GET_AUTH_SUMMARY_ADDRESS_SUCCESS: {
      draft.isLoading = false;
      const { currentAuthId } = draft;
      const { response } = action;

      const destinationAddressId = response.authorizationDetails?.destinationAddressId;

      const updatedAddresses = response.addresses?.map(address => {
        const isDestinationType = isIdEqual(address.addressTypeId, 'C467FD82-E2D4-4D26-8827-5DF0A0B5C6A5');

        return {
          ...address,
          excludeAddressFromSelection: isDestinationType && address.addressId !== destinationAddressId
        };
      });

      draft.authorizationDetails[currentAuthId].addresses = [...updatedAddresses];
      draft.authorizationDetails[currentAuthId].authorizationDetails = { ...response.authorizationDetails };
      break;
    }

    case POST_AUTHORIZATIONS_SUCCESS:
      draft.authorizationDetails[action.response.authorizationDetails.fileId] = action.response;
      break;

    case UPDATE_AUTH_CUSTOM_FIELD_VALUE_SUCCESS:
      draft.authorizationDetails[action.response.authorizationDetails.fileId].customFieldValues = action.response;
      break;

    case GET_EMPLOYEE_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.employee = action.response;
      break;

    case GET_SO_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.significantOther = action.response;
      break;

    case GET_COMMUNICATION_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.communication = action.response;
      break;

    case GET_AUTH_CLIENT_POLICIES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.authClientPolicies = action.response;
      break;

    case GET_AUTH_SERVICES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.authServices = action.response;
      break;

    case UPDATE_SO_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.significantOther = action.response;
      break;

    case UPDATE_EMPLOYEE_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.employee = action.response;
      break;

    case UPDATE_COMMUNICATION_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.communication = action.response;
      break;

    case UPDATE_AUTH_CLIENT_POLICIES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.authClientPolicies = action.response;
      break;

    case UPDATE_AUTH_SERVICES_SUCCESS:
      if (draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId].services = action.response;
      break;

    case UPDATE_USER_SETTINGS_SUCCESS:
      if (draft.authorizationDetails[draft.currentAuthId])
        draft.authorizationDetails[draft.currentAuthId].authDetails.userSettings = action.response;
      break;

    case POST_EMPLOYEE_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.employee = action.response;
      break;

    case POST_SO_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.significantOther = action.response;
      break;

    case POST_AUTH_SERVICES_SUCCESS:
      if (draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId].services = action.response;
      break;

    case UPDATE_AUTH_DATE_SUMMARY_SUCCESS:
    case GET_AUTH_DATE_SUMMARY_SUCCESS:
    case POST_AUTH_DATE_SUMMARY_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.dateSummary = action.response;
      break;

    case POST_COMMUNICATION_INFO_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.communication = action.response;
      break;

    case POST_AUTH_CLIENT_POLICIES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.authClientPolicies = action.response;
      break;

    case GET_DEPARTURE_ADDRESS_SUCCESS:
    case UPDATE_DEPARTURE_ADDRESS_SUCCESS:
    case POST_DEPARTURE_ADDRESS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.departureAddress = action.response;
      break;

    case UPDATE_DESTINATION_ADDRESS_SUCCESS:
    case GET_DESTINATION_ADDRESS_SUCCESS:
    case POST_DESTINATION_ADDRESS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.destinationAddress = action.response;
      break;

    case GET_AUTH_LIST_CLIENT_POLICIES_REQUEST:
      draft.clientPoliciesLoading = true;
      break;

    case GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS:
      draft.clientPoliciesLoading = false;
      draft.clientPolicies = action.response;
      break;

    case GET_AUTH_LIST_CLIENT_POLICIES_FAILURE:
      draft.clientPoliciesLoading = false;
      break;

    case GET_AUTH_TEAM_SUCCESS:
    case UPDATE_AUTH_TEAM_SUCCESS:
    case POST_AUTH_TEAM_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].teamMembers = action.response;
      break;

    case POST_USER_SETTINGS_SUCCESS:
      if (draft.authorizationDetails[draft.currentAuthId])
        draft.authorizationDetails[draft.currentAuthId].authDetails.userSettings = action.response;
      break;

    case GET_ACTIVITY_LOG_REQUEST:
      draft.isLoading = true;
      break;

    case GET_FAMILY_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.family = action.response;
      break;

    case UPDATE_FAMILY_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].familyMembers = action.response;
      break;
    }

    case POST_FAMILY_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].familyMembers = action.response;
      break;
    }

    case UPDATE_FAMILY_DATA: {
      draft.authorizationDetails[draft.currentAuthId].familyMembers = action.response;
      break;
    }

    case GET_FAMILY_PET_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.familyPets = action.response;
      break;

    case UPDATE_FAMILY_PET_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].pets = action.response;
      break;
    }

    case POST_FAMILY_PET_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].pets = action.response;
      break;
    }

    case UPDATE_FAMILY_PET_DATA: {
      draft.authorizationDetails[draft.currentAuthId].pets = action.response;
      break;
    }

    case GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].authDetails.clientPoliciesByClient = action.response;
      break;
    }

    case UPDATE_AUTHORIZATIONS_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].authorizationDetails = action.response;
      break;
    }

    case GET_ADDRESS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.addresses = action.response;
      break;

    case UPDATE_ADDRESS_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].addresses = action.response;
      break;
    }

    case POST_ADDRESS_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].addresses = action.response;
      break;
    }

    case DELETE_ADDRESS_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].addresses = action.response;
      break;
    }

    case GET_AUTH_TRIPS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.authTrips = action.response;
      break;

    case UPDATE_AUTH_TRIP_SUCCESS: {
      let authTrips = draft.authorizationDetails[draft.currentAuthId]?.authDetails?.authTrips;
      if (action.response && authTrips && Array.isArray(authTrips)) {
        const index = authTrips.findIndex(item => item.tripId === action.response.tripId);
        if (index !== -1) {
          authTrips[index] = { ...action.response };
          draft.authorizationDetails[draft.currentAuthId].authDetails.authTrips = authTrips;
        }
      }
      break;
    }

    case POST_AUTH_TRIP_SUCCESS: {
      let authTrips = draft.authorizationDetails[draft.currentAuthId].authDetails.authTrips;
      if (action.response && authTrips && Array.isArray(authTrips)) {
        authTrips.push(action.response);
        draft.authorizationDetails[draft.currentAuthId].authDetails.authTrips = authTrips;
      }
      break;
    }

    case DELETE_AUTH_TRIP_SUCCESS: {
      let authTrips = draft.authorizationDetails[draft.currentAuthId].authDetails.authTrips;
      if (action.response && authTrips && Array.isArray(authTrips)) {
        authTrips = authTrips.filter(a => a.tripId !== action.response.tripId);
        draft.authorizationDetails[draft.currentAuthId].authDetails.authTrips = authTrips;
      }
      break;
    }

    case GET_AUTHORIZATION_BANKING_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authDetails.banking = action.response;
      break;

    case POST_AUTHORIZATION_BANKING_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].bankAccounts = action.response;
      break;
    }

    case UPDATE_AUTHORIZATION_BANKING_SUCCESS: {
      draft.authorizationDetails[draft.currentAuthId].bankAccounts = action.response;
      break;
    }
    case DELETE_AUTHORIZATION_BANKING_SUCCESS: {
      let authBanks = draft.authorizationDetails[draft.currentAuthId].authDetails.banking;
      if (action.response && authBanks && Array.isArray(authBanks)) {
        authBanks = authBanks.filter(a => a.bankId !== action.response.bankId);
        draft.authorizationDetails[draft.currentAuthId].authDetails.banking = authBanks;
      }
      break;
    }

    case POST_TRANSFEREE_SURVEY_SUCCESS: {
      const updateSummaryIndex = draft.authorizationSummaries.findIndex(auth => auth.fileId === action.response.authorizationFileId);
      draft.authorizationSummaries[updateSummaryIndex].surveySent = true;
      break;
    }

    case GET_EXPENSE_BY_AUTHORIZATION_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].expenses = action.response;
      break;

    case GET_APPROVED_LINEITEM_SUMMARIES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].approvedLineItems = action.response;
      break;

    case GET_AUTHORIZATION_SENT_TEMPLATES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].sentEmailTemplates = action.response;
      break;

    default:
      break;
  }
  return draft;
};

export default handleAuthorizationReducer;
